import global from "./global.js";

import {KalmanFilter} from "kalman-filter";

import ConstantSpeed    from "./kalman/ConstantSpeed.js";
import ConstantPosition from "./kalman/ConstantPosition.js";
import ConstantSpeedDynamicRange from "./kalman/ConstantSpeedDynamicRange.js";

import Error from "./utils/Error.js";

const log = global.log.getLogger("f_mtac.scene.projection.kalman");

global.kalman = {ConstantSpeed, ConstantPosition, ConstantSpeedDynamicRange, selected: ConstantPosition};

window.KalmanFilter = KalmanFilter;

const Filter = function() {
    var t = [0], state = null;
    var kalman = global.kalman.selected();

    this.reset = () => {
        t = [0];
        kalman = global.kalman.selected();
    };

    this.feed = ({observation, time}) => {
        try {
            const dt = time - t[t.length - 1];
            if(typeof(dt) !== "number" || isNaN(dt) || dt <= 0){
                throw new Error.build.invalid({
                    message: `dt should be positive number tn+1 = ${time} tn=${t[t.length - 1]}`
                });
            }
            t.push(time);
            state = kalman.filter({previousCorrected: state, observation});
        } catch (error) {
            log.error("the filter is broken because of some unexpected error, resetting", error);
            t = [0];
            kalman = global.kalman.selected();
        }
        return state;
    };
};

export default Filter;
